export default {
    hiddenTeamMembers: 'Hidden Team Members',
    moreReviewersPill: 'And {{count}} more reviewers',
};
